import axios from 'axios'
import { getToken, logout } from '@/utils/user'

const isTestENV = process.env.NODE_ENV === 'production' ? false : true

const HTTP = axios.create({
  baseURL: (isTestENV ? '/test' : '') + '/api/user/',
  timeout: 10000 // 超过 10 秒未响应则判定为响应超时
})

// 请求拦截器
HTTP.interceptors.request.use(
  config => {
    config.headers.token = getToken()
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
HTTP.interceptors.response.use(
  res => {
    let resData = res.data
    let resultCode = parseInt(resData.resultCode)
    console.log(`%c${res.config.url} 返回数据：`, 'color: green', resData)
    if (resultCode !== 0) {
      let error = new Error(resData.resultMsg)
      error.name = resultCode
      // 110, 111 代表 token 失效，需重新登录
      if ([110, 111].includes(resultCode)) {
        logout('登录信息失效')
      } else {
        handleFail(error)
      }
      return Promise.reject(error)
    }
    return resData.data
  },
  error => {
    handleFail(error)
    return Promise.reject(error)
  }
)

function handleFail(error) {
  console.table(error)
}

export default HTTP
